export enum StoreItemPurchaseType {
    Points = 0,
    Gems = 1,
    Diamonds = 2,
}